<tyl-button style="display: flex;"
            *ngIf="!useLink && !disabled"
            [image]="image"
            [label]="label" 
            [showLabel]="showLabel" 
            [iconWidth]="iconWidth"
            yPosition="below" 
            [matMenuTriggerFor]="actionMenu"
            (click) = "$event.stopPropagation()">
</tyl-button>

<tyl-button *ngIf="!useLink && disabled"
    style="display: flex;"
    (click) = "$event.stopPropagation()"
    yPosition="below"
    [label]="label"
    [showLabel]="showLabel"
    [iconWidth]="iconWidth"
    [image]="image"
    [disabledImage]="disabledImage"
    [disabled]="disabled">
</tyl-button>

<a *ngIf="useLink"
    [matMenuTriggerFor]="actionMenu"
   (click) = "$event.stopPropagation()">
    {{label | translate}}
</a>

<mat-menu #actionMenu="matMenu" [overlapTrigger]="false">
    <div style="display: flex;flex-direction: column;">
        <div *ngIf="showNoRowSelectedMsg" style="padding-left: 10px;padding-right: 10px;text-align: center;">
            <span style="color: #b71c1c;">
                At least one checkbox must be selected<br>in order to use these options.
            </span>
        </div>
        <div *ngFor="let item of topMenuItems; let i = index" >
            <button mat-menu-item class="menuItem" 
                    *ngIf="item != 'mat-divider'"
                    (click)="topMenuItemClicked(i)" >     
                <div>
                    <span [ngStyle]="{'color': this.isTopMenuItemDisabled(i) ? 'lightgray' : 'inherit'}" translate>{{item}}</span>
                </div>               
            </button>
            <mat-divider *ngIf="item == 'mat-divider'"></mat-divider>
        </div>
        <ng-content class="menuItem"></ng-content>
        <div *ngFor="let item of bottomMenuItems; let i = index" >
            <button mat-menu-item class="menuItem" 
                    *ngIf="item != 'mat-divider'"
                    (click)="bottomMenuItemClicked(i)" >     
                <div>
                    <span [ngStyle]="{'color': this.isBottomMenuItemDisabled(i) ? 'lightgray' : 'inherit'}" translate>{{item}}</span>
                </div>               
            </button>
            <mat-divider *ngIf="item == 'mat-divider'"></mat-divider>
        </div>

    </div>
</mat-menu>


